/** The backend's refusal of a sign-up for an address with no pending invite (`backend/src/lib/signupGate.ts`). */
const INVITE_REQUIRED = 'invite_required';

export const INVITE_REQUIRED_MESSAGE =
  'There is no invite for this email address. RosaHouse accounts are by invitation: ask a project admin to invite you, then sign up with the address the invite was sent to.';

/** An email sign-up answer carries `code`; a Google sign-up comes back with the code alone. */
export function authErrorMessage(
  error: { code?: string; message?: string } | string,
  fallback: string,
): string {
  const { code, message } = typeof error === 'string' ? { code: error, message: undefined } : error;
  if (code?.toLowerCase() === INVITE_REQUIRED || message === INVITE_REQUIRED) {
    return INVITE_REQUIRED_MESSAGE;
  }
  return message || fallback;
}

/** better-auth sends a failed Google sign-in back to the error URL with `?error=<code>`. */
export function readOAuthError(): string | null {
  return new URLSearchParams(window.location.search).get('error');
}

export function clearOAuthError(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('error')) return;
  url.searchParams.delete('error');
  url.searchParams.delete('error_description');
  history.replaceState(history.state, '', `${url.pathname}${url.search}${url.hash}`);
}
